import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './components/dashboard/Dashboard.vue';
import UserOverview from './components/users/UserOverview.vue';
import UserEdit from './components/users/UserEdit.vue';
import Fax from './components/fax/Fax.vue';
import PhoneNumbersOverview from './components/phone-numbers/PhoneNumbersOverview.vue';
import Rates from './components/rates/Rates.vue';
import PhoneNumbersOrder from './components/phone-numbers/PhoneNumbersOrder.vue';
import Login from './components/login/Login.vue';
import Account from './components/account/Account.vue';
import CallsOverview from './components/calls/CallsOverview.vue';
import Support from './components/support/Support.vue';
import DownloadApp from './components/download-app/DownloadApp.vue';
import Wizard from './components/wizard/Wizard.vue';
import GroupsOverview from './components/groups/GroupsOverview.vue';
import GroupsEdit from './components/groups/GroupsEdit.vue';
import HotlineEdit from './components/groups/HotlineEdit.vue';
import Conference from './components/conference/Conference.vue';
import Invoices from './components/invoices/Invoices.vue';
import { isLoggedIn } from '@/services/Authentication';
import store from './store/store';
import UserService from '@/services/UserService';
import FaxUserService from '@/services/FaxUserService';
import SupportUserService from '@/services/SupportUserService';
import AddressBook from '@/components/address-book/AddressBook.vue';
import Tariff from '@/components/tariff/Tariff.vue';
import {TOGGLE_USER_LIMIT_FOR_DASHBOARD} from '@/store/mutation-types';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            component: Dashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/wizard/:type',
            component: Wizard,
            meta: { requiresAuth: true }
        },
        {
            path: '/groups',
            component: GroupsOverview,
            meta: { requiresAuth: true }
        },
        {
            path: '/groups/newGroup',
            component: GroupsEdit,
            meta: { requiresAuth: true }
        },
        {
            path: '/groups/hotline',
            component: HotlineEdit,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (to.query.mode === 'edit' && store.getters.isHotlineCreated && store.getters.isPremium) {
                    next();
                }
                if (to.query && to.query.mode !== 'edit' && !store.getters.isHotlineCreated && store.getters.isPremium) {
                    next();
                }
            }
        },
        {
            path: '/groups/:id',
            component: GroupsEdit,
            meta: { requiresAuth: true }
        },
        {
            path: '/users',
            component: UserOverview,
            meta: { requiresAuth: true }
        },
        {
            path: '/users/newUser',
            component: UserEdit,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                UserService.getAllUsers().then(response => {
                    const userList = response.data;
                    FaxUserService._removeFaxUserFromList(userList);
                    SupportUserService._removeSupportUserFromList(userList);
                    if (userList.length === 10) {
                        store.commit(TOGGLE_USER_LIMIT_FOR_DASHBOARD, true);
                    } else {
                        next();
                    }
                });
            }
        },
        {
            path: '/users/:id',
            component: UserEdit,
            meta: { requiresAuth: true }
        },
        {
            path: '/account',
            component: Account,
            meta: { requiresAuth: true }
        },
        {
            path: '/address-book',
            component: AddressBook,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (store.getters.isPremium) {
                    next();
                } else {
                    next(false);
                }
            }
        },
        {
            path: '/calls-overview',
            component: CallsOverview,
            meta: { requiresAuth: true }
        },
        {
            path: '/support',
            component: Support,
            meta: { requiresAuth: true }
        },
        {
            path: '/download-app',
            component: DownloadApp,
            meta: { requiresAuth: true }
        },
        {
            path: '/fax',
            component: Fax,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (store.getters.isPremium) {
                    next();
                } else {
                    next(false);
                }
            }
        },
        {
            path: '/phone-numbers',
            component: PhoneNumbersOverview,
            meta: { requiresAuth: true }
        },
        {
            path: '/rates',
            component: Rates,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (store.getters.isPremium) {
                    next();
                } else {
                    next(false);
                }
            }
        },
/*         {
            path: '/phone-numbers-order',
            component: PhoneNumbersOrder,
            meta: { requiresAuth: true },
        }, */
        {
            path: '/conference',
            component: Conference,
            meta: { requiresAuth: true }
        },
        {
            path: '/invoices',
            component: Invoices,
            meta: { requiresAuth: true }
        },
        {
            path: '/tariff',
            component: Tariff,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (!store.getters.isPremium) {
                    next();
                } else {
                    next(false);
                }
            }
        },
        {
            path: '*',
            redirect: '/'
        },
    ]
});

router.beforeEach((to: any, from: any, next: any) => {
    if (to.matched.some((record: any) => record.meta.requiresAuth)) {
        if (!isLoggedIn()) {
            next({
                path: '/login'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router;
